import { useDialog } from "@/client/stores/dialog";
import { ManualCreateUserDto } from "@reactive-resume/dto";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormLabel,
  Input,
  FormItem,
  FormControl,
} from "@reactive-resume/ui";
import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useCreateRate } from "@/client/services/rate/create";
import { CreateRateDto, UpdateRateDto } from "libs/dto/src/rate";
import { useUpdateRate } from "@/client/services/rate/update";
import { useRate } from "@/client/services/rate/rate";
import { Value } from "@radix-ui/react-select";

export const CreateRateDialog = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const { createRate } = useCreateRate();
  const { updateRate } = useUpdateRate();
  const { isOpen, mode, close, payload } = useDialog<{ id: string } | undefined>("create-rate");

  let isEdit = !!payload?.item?.id;
  const rateId = payload?.item?.id;

  const { rate } = useRate(rateId ?? "");

  const form = useForm<CreateRateDto | UpdateRateDto>({
    defaultValues: {
      name: "",
      price: 0,
      credit: 1,
    },
  });

  useEffect(() => {
    if (isEdit && rate) {
      form.reset({
        name: rate.name,
        price: rate.price,
        credit: rate.credit,
      });
    }
    if (!isEdit) {
      form.reset({
        name: "",
        price: 0,
        credit: 1,
      });
    }
  }, [rate, isEdit, form]);

  const OnSubmit = async (data: any) => {
    try {
      if (isEdit && rateId) {
        data.price = new Number(data.price);
        data.credit = new Number(data.credit);
        await updateRate({ id: rateId, data });
      } else {
        data.price = new Number(data.price);
        data.credit = new Number(data.credit);
        await createRate(data);
      }
      form.reset();
      close();
    } catch {
      form.reset();
    }
  };
  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          {isEdit ? (
            <>
              <DialogTitle>Modifier le Tarif</DialogTitle>
            </>
          ) : (
            <>
              <DialogTitle>Nouveau Tarif</DialogTitle>
            </>
          )}
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <FormField
              name="name"
              control={form.control}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{`Nom`}</FormLabel>
                  <FormControl>
                    <Input {...field} required />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              name="price"
              control={form.control}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{`Prix`}</FormLabel>
                  <FormControl>
                    <Input {...field} required />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              name="credit"
              control={form.control}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{`Nombre de crédits`}</FormLabel>
                  <FormControl>
                    <Input {...field} required />
                  </FormControl>
                </FormItem>
              )}
            />
            <div className="flex-rows flex justify-center gap-x-2">
              <Button type="submit" className="bg-moncvpro-secondary flex-1">
                {"Valider"}
              </Button>

              <Button className="bg-moncvpro-primary flex-1" onClick={close}>
                {"Fermer"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
